import { Injectable } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfirmDeleteComponent } from '../shared-modal/confirm-delete/confirm-delete.component';
import { ConfirmModalComponent } from '../shared-modal/confirm-modal/confirm-modal.component';
import { BidConfirmComponent } from '../shared-modal/bid-confirm/bid-confirm.component';
import { ConfirmResolveDisputeComponent } from '../shared-modal/confirm-resolve-dispute/confirm-resolve-dispute.component';

@Injectable({
  providedIn: 'root'
})


@Injectable()
export class SharedModalService {
  constructor(public dialog: MatDialog) { }

  // alert(title, description): Observable<any> {
  //   const dialogRef = this.dialog.open(AlertModalComponent, {
  //     height: 'auto',
  //     width: '570px',
  //     role: 'alertdialog',
  //     position: { top: '100px' },
  //     data: { title: title, description: description }
  //   });
  //   return dialogRef.componentInstance.onDataRecieved;
  // }

  confirm(title, description): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      height: 'auto',
      width: '480px',
      role: 'alertdialog',
      data: { title: title, description: description }
    });
    return dialogRef.componentInstance.onDataRecieved;
  }

  /**
   * The same confirm popup, but it always answers: true when Yes is chosen, false when No is chosen or the popup is
   * closed any other way (the close icon, the backdrop, Escape). confirm() above never answers for No, so a caller
   * that has to undo something on No uses this.
   */
  confirmDecision(title, description): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      height: 'auto',
      width: '480px',
      role: 'alertdialog',
      data: { title: title, description: description }
    });
    let confirmed = false;
    dialogRef.componentInstance.onDataRecieved.subscribe((answer: boolean) => {
      if (answer === true) {
        confirmed = true;
      }
    });
    return dialogRef.afterClosed().pipe(take(1), map(() => confirmed));
  }

  confirmBid(title, description, componentData = {}): Observable<any> {
    const dialogRef = this.dialog.open(BidConfirmComponent, {
      height: 'auto',
      width: '480px',
      role: 'alertdialog',
      data: { title: title, description: description, componentData: componentData }
    });
    return dialogRef.componentInstance.onDataRecieved;
  }

  resolveDisputeConfirm(title, description): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmResolveDisputeComponent, {
      height: 'auto',
      width: '480px',
      role: 'alertdialog',
      data: { title: title, description: description }
    });
    return dialogRef.componentInstance.onDataRecieved;
  }

  public delete(description): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '480px',
      role: 'alertdialog',
      disableClose: true,
      data: { description: description }
    });
     return dialogRef.componentInstance.onDataReceived;
  }


}

 
